import React, {useState} from 'react'
import {CircularProgress} from '@mui/material'
import ViewEstampRequest from './Components/ViewEstampRequest'
import {requestTableDataType} from './EstampRequestDataType'

const PendingRequests = ({
  loading,
  listRequests,
  noErequestFound,
  setBadgeColor,
  formatDate,
  requestStatus,
  getListEstamp,
  lastUpdated,
}: requestTableDataType) => {
  const [itemOffset, setItemOffset] = useState<number>(0)
  const [dataLength, setDataLength] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [showViewModal, setShowViewModal] = useState<string | null>(null)
  const itemsPerPage = 10
  const pageCount = Math.ceil(dataLength / itemsPerPage)

  function formatDateWithoutYear(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    }
    return new Intl.DateTimeFormat('en-US', options).format(date)
  }
  return (
    <>
      {loading ? (
        // {* Begin: loader*}
        <div
          className='d-flex justify-content-center align-items-center vh-70'
          style={{height: '70vh'}}
        >
          <CircularProgress />
        </div>
      ) : (
        // {* End: loader*}
        <div className='app-main flex-column flex-row-fluid'>
          {/* Begin: Heading part */}
          <div className='d-flex align-items-center gap-2 gap-lg-3 justify-content-between mb-2 px-5'>
            {/* Begin: Heading */}
            <h2
              className='page-heading d-flex text-dark fw-bold fs-3 my-0
            flex-column justify-content-center'
            >
              {requestStatus === 1
                ? 'Completed Requests'
                : requestStatus === 2
                ? 'Pending Requests'
                : 'Requests'}
            </h2>
            {/* End: Heading */}
            <div className='d-flex align-items-center'>
              {lastUpdated && (
                <span className='me-2'>
                  <p className='my-1'>{`Last updated: ${formatDateWithoutYear(lastUpdated)}`}</p>
                </span>
              )}
              <button
                type='button'
                className='py-1 my-2 btn btn-sm fw-bold btn-primary'
                onClick={() => getListEstamp()}
              >
                <i className='bi bi-arrow-repeat text-white fs-4'></i>
                <span className='me-2'>Refresh</span>
              </button>
            </div>
          </div>
          {/* End: Heading part */}

          {/* Begin: Table */}
          <div id='table div'>
            <div className='card mb-5 mb-xl-8'>
              <div className='card-body py-3'>
                <div className='table-responsive'>
                  {/* begin::Table */}
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    {/* begin::Table head */}
                    {!noErequestFound && (
                      <thead>
                        <tr className='fw-bold text-muted'>
                          <th className='max-w-150px'>Property Name</th>
                          <th className='max-w-150px'>User Name</th>
                          <th className='max-w-150px'>eStamp Date and Time</th>
                          <th className='max-w-100px'>status</th>
                          <th className='max-w-50px'>Actions</th>
                        </tr>
                      </thead>
                    )}
                    {/* end::Table head */}

                    {/* begin::Table body */}
                    <tbody>
                      {noErequestFound ? (
                        <tr>
                          <td colSpan={5}>
                            <span className='d-flex flex-column align-items-center flex-start p-10'>
                              <img
                                src='/media/svg/undraw/document.svg'
                                alt='No document uploaded'
                                className='h-200px w-200px'
                              />
                              <span className='fw-bold text-muted fs-1 text-center'>
                                No Estamp request is present
                              </span>
                            </span>
                          </td>
                        </tr>
                      ) : (
                        listRequests?.map((request: any, index: number) => {
                          return (
                            <tr key={index}>
                              <td className='max-w-150px'>
                                <div className='d-flex justify-content-start flex-column'>
                                  <span
                                    className='text-truncate max-w-150px text-dark fw-bold text-hover-primary fs-6'
                                    title={request.property_title}
                                  >
                                    {request.property_title}
                                  </span>
                                </div>
                              </td>
                              <td className='max-w-200px'>
                                <div className='d-flex justify-content-start flex-column'>
                                  <div
                                    className='text-truncate max-w-200px text-dark fw-bold text-hover-primary fs-6'
                                    title={request.accouont_holder_name}
                                  >
                                    {request.accouont_holder_name}
                                  </div>
                                  <span
                                    className='text-truncate max-w-200px text-muted fw-semibold text-muted d-block fs-7'
                                    title={request.email_id}
                                  >
                                    {request.email_id}
                                  </span>
                                </div>
                              </td>
                              <td className='max-w-200px'>
                                <div className='d-flex justify-content-start flex-column'>
                                  <div
                                    className='text-dark fw-bold text-hover-primary fs-6 text-truncate max-w-200px'
                                    title={request.created_date}
                                  >
                                    {formatDate(new Date(request.created_date))}
                                  </div>
                                </div>
                              </td>
                              <td className='max-w-100px'>
                                <span
                                  className={`badge ${setBadgeColor(
                                    request.estamp_status_msg === 'Pending'
                                      ? 0
                                      : request.estamp_status_msg === 'Completed'
                                      ? 1
                                      : 2
                                  )}`}
                                >
                                  {request.estamp_status_msg}
                                </span>
                              </td>
                              <td className='max-w-50px'>
                                <div className='d-flex flex-shrink-0'>
                                  <div
                                    onClick={() =>
                                      setShowViewModal(request.document_signing_order_uuid)
                                    }
                                    className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  >
                                    <i
                                      className='bi bi-eye-fill bi-4x fs-2'
                                      title='View KYC Account'
                                    ></i>
                                  </div>
                                  {showViewModal === request.document_signing_order_uuid && (
                                    <ViewEstampRequest
                                      show={showViewModal}
                                      handleClose={() => setShowViewModal(null)}
                                      request={request}
                                      formatDate={formatDate}
                                      getListEstamp={getListEstamp}
                                      requestStatus={requestStatus}
                                    />
                                  )}
                                </div>
                              </td>
                            </tr>
                          )
                        })
                      )}
                    </tbody>
                    {/* end::Table body */}
                  </table>
                  {/* end::Table */}
                </div>
              </div>
            </div>
          </div>
          {/* End: Table */}

          {/* Begin: Pagination */}
          {/* {pendingRequests && pageCount > 1 && (
            <PaginationComponent
              itemsPerPage={itemsPerPage}
              dataLength={dataLength}
              setItemOffset={setItemOffset}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pageCount={pageCount}
            />
          )} */}
          {/* End: Pagination */}
        </div>
      )}
    </>
  )
}

export default PendingRequests
